import {
    Popover,
    Typography,
} from '@mui/material';
import { Trans } from 'react-i18next'
function GenerateInfoPopover(props) {

    return (
        <>
            <Popover
                {...props}
            >
                <Typography sx={{ width: 350, p: 2 }}>
                    <Trans ns='workRecordsPage' i18nKey="info.lang">
                        Die detailierte Aufschlüsslung enthält die Arbeitszeiten pro Arbeitstag,
                        inklusive der Pausen und wann diese genommen wurden.
                    </Trans>
                </Typography>
                <Typography sx={{ width: 350, px: 2, pb: 2 }}>
                    <Trans ns='workRecordsPage' i18nKey="info.kurz">
                        Die kurze Version der Arbeitsnachweise
                        enthält lediglich Zeiten für Kommen und Gehen am jeweiligen Arbeitstag, die Gesamtarbeits- sowie Pausenzeit.
                    </Trans>
                </Typography>
            </Popover>
        </>
    );
};

export default GenerateInfoPopover
